module.exports = __webpack_public_path__ + "static/gerry-mugford-a67fbab38e76fc783510a8a6a1ac08c3.png";